export default __webpack_public_path__ + "locales/sl/ChangeEmailDialog.json?hash=80aa75a689202eea86ae58d70b12b3be";